import { Injectable } from '@angular/core';
import { Constants } from '../core/enums/constants.enum';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  public getItem(key: string, storageType: 'local' | 'session' = 'local') {
    let item;
    try {
      if (storageType === 'local') {
        item = localStorage.getItem(key);
      } else {
        item = sessionStorage.getItem(key);
      }
      if (item) {
        item = JSON.parse(item);
      }
    } catch (ex) {
      console.error(`Unable to retrieve item from ${storageType}Storage. Error: ${ex}`);
    }
    return item;
  }

  public setItem(key: string, item: any, storageType: 'local' | 'session' = 'local') {
    try {
      const stringObject = JSON.stringify(item);
      if (storageType === 'local') {
        localStorage.setItem(key, stringObject);
      } else {
        sessionStorage.setItem(key, stringObject);
      }
    } catch (ex) {
      console.error(`Unabe to set item in ${storageType}Storage. Error: ${ex}`);
    }
  }

  public removeItem(key: string, storageType: 'local' | 'session' = 'local') {
    if (storageType === 'local') {
      localStorage.removeItem(key);
    } else {
      sessionStorage.removeItem(key);
    }
  }
}
